import { render, staticRenderFns } from "./ShopNews.vue?vue&type=template&id=cba9fe9c"
import script from "./ShopNews.vue?vue&type=script&lang=js"
export * from "./ShopNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports